module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/2/2-14341ea513af46e4bf953a88ce0ad226.jpg";